import { render } from "./BackgroundFlares.vue?vue&type=template&id=a7f9f5e8&scoped=true"
import script from "./BackgroundFlares.vue?vue&type=script&lang=js"
export * from "./BackgroundFlares.vue?vue&type=script&lang=js"

import "./BackgroundFlares.vue?vue&type=style&index=0&id=a7f9f5e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f9f5e8"]])

export default __exports__